export const inputType = {
    EMAIL: 1,
    PASSWORD: 2,
    TEXT: 3,
    NUMBER: 4,
    SELECT: 5,
    DATE: 6,
    DATETIME: 7
}